<script setup lang="ts">
/**
 * Module: web/src/views/ForbiddenView.vue
 * Author: Salvo Praxis (w/ AI pair programming partner Claude Code by Anthropic)
 * Version: 1.0.0
 * Date: 2026-07-08
 *
 * 403 landing (doc 04 sect 9.4 guard target). Mobile-first single column.
 */
import { useAuthStore } from '@/stores/auth';
import AppIcon from '@/components/AppIcon.vue';

const auth = useAuthStore();
</script>

<template>
  <div class="flex flex-col items-center justify-center px-4 py-16 text-center">
    <div class="w-14 h-14 rounded-2xl bg-accent-bad/10 border border-accent-bad/30 flex items-center justify-center mb-4">
      <AppIcon name="lock" class="w-7 h-7 text-accent-bad" />
    </div>
    <h1 class="text-xl font-bold text-fg mb-1">No access to that page</h1>
    <p class="text-sm text-fg-muted max-w-sm mb-6">
      Your account doesn't hold the capability that page needs. If you think it should, ask a manager
      to adjust your access.
    </p>
    <RouterLink :to="auth.landingPath" class="btn-primary">Back to your workspace</RouterLink>
  </div>
</template>
